import { TextFieldProps, SxProps, Theme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React from "react";
import useConditionalTranslation from "../../utils/hooks/useConditionalTranslation";

export interface DateFieldProps
  extends Omit<TextFieldProps, "InputProps" | "variant" | "onChange"> {
  label?: string;
  placeholder?: string;
  value: Date | null;
  containerStyle?: React.CSSProperties;
  ignoreLocale?: boolean;
  datePickerStyle?: SxProps<Theme>;
  clearable?: boolean;
  onChange?: (value: Date | null) => void;
}

const DateField = ({
  id,
  label = "",
  value,
  onChange,
  placeholder = "",
  helperText = null,
  fullWidth = true,
  required = false,
  containerStyle = null,
  disabled = false,
  className = "",
  ignoreLocale = false,
  datePickerStyle = null,
  clearable = false,
}: DateFieldProps) => {
  const [tLabel, tPlaceholder, tHelperText] = useConditionalTranslation([
    label,
    placeholder,
    helperText?.toString(),
  ]);

  const format = "dd/MM/yyyy";

  const name = `${tLabel}${required ? " *" : ""}`;

  return (
    <DatePicker
      enableAccessibleFieldDOMStructure={false}
      label={name}
      disabled={disabled}
      value={value}
      onChange={onChange}
      format={format}
      className={className}
      sx={datePickerStyle}
      slotProps={{
        field: { clearable },
        textField: {
          id,
          fullWidth,
          helperText: tHelperText,
          placeholder: tPlaceholder,
          InputLabelProps: {
            shrink: true,
          },
          style: containerStyle,
        },
      }}
    />
  );
};

DateField.defaultProps = {
  placeholder: "",
  label: "",
  containerStyle: null,
};

export default DateField;
